export default __webpack_public_path__ + "static/media/scan-border-1.bff9f2fe.svg";